import { render, staticRenderFns } from "./cc_type.input.vue?vue&type=template&id=36370da4&"
import script from "./cc_type.input.vue?vue&type=script&lang=ts&"
export * from "./cc_type.input.vue?vue&type=script&lang=ts&"
import style0 from "./cc_type.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports